<template>
  <div>
    <div class="cards-counter">{{currentCard}}/{{cardsTotal}}</div>
    <div id="slider">
      <transition-group tag="div" :name="transitionName" class="slides-group">
        <div v-if="show" :key="current" class="flashcard-slide">
          <div class="flashcards-card-wrapper">
            <div
              class="card"
              :class="{'go' : backSideShown}"
              tabindex="0"
              @click="onShowAnotherSide()"
              @keydown.13="onShowAnotherSide()">
              <div class="front" :class="cardColor">
                <img v-if="currentSlide.front_image_url" :src="currentSlide.front_image_url">
                {{currentSlide.front}}
              </div>
              <div class="back" :class="cardColor">
                <img v-if="currentSlide.back_image_url" :src="currentSlide.back_image_url">
                {{currentSlide.back}}
              </div>
            </div>

          </div>
        </div>
      </transition-group>
    </div>

    <div class="play-audio-wrapper">
      <div v-if="audioUrl && enableAudio">
        <audio ref="audioPlayer" :key="audioUrl">
          <source :src="audioUrl" type="audio/mpeg" />
        </audio>
        <a
          href="javascript:void(0);"
          :class="{ playing: isPlaying }"
          @click="onPlayAudio"
          title="Play Audio"
        ></a>
      </div>
    </div>

    <div class="slider-buttons">
      <a href="javascript:void(0);" class="btn btn-prev" aria-label="Previous card" @click="slide(-1)"></a>
      <a href="javascript:void(0);" class="btn btn-next" aria-label="Next card" @click="slide(1)"></a>
    </div>
  </div>
</template>


<script>
import { shuffle } from 'lodash'

export default {
  props: {
    cards: {
      type: Array,
      required: true
    },
    frontFirst: {
      type: Boolean,
      required: true
    },
    shuffleOn: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      current: 0,
      direction: 1,
      show: false,
      transitionName: "fade",
      slides: this.cards,
      slidesNew: this.slides,
      backSideShown: false,
      isPlaying: false,
      backFirst: false,
      audio: {},
      indexColor: 0,
      enableAudio: false
    }
  },

  computed: {
    cardsTotal() {
      return this.cards.length
    },
    currentCard() {
      return this.current + 1
    },
    cardColor() {
      return 'color' + this.indexColor
    },
    currentSlide() {
      return this.slides[this.current]
    },
    audioUrl() {
      return this.currentSlide.front_audio_url || this.currentSlide.back_audio_url || null
    }
  },

  watch: {
    shuffleOn() {
      this.initShuffleSlides()
    },

    frontFirst() {
      this.showCardsSide()
    }
  },

  mounted() {
    this.show = true;
    this.$nextTick(() => {
      this.audio = this.$refs.audioPlayer;
    });

   this.enableAudioCheck()
  },

  methods: {
    slide(dir) {
      this.direction = dir;
      dir === 1
        ? (this.transitionName = "slide-next")
        : (this.transitionName = "slide-prev");
      const len = this.slides.length;
      this.current = (this.current + dir % len + len) % len;

      this.indexColor = this.current % 5

      this.stopPlayingAudio()

      this.backSideShown = false
      this.enableAudioCheck()
    },

    onShowAnotherSide() {
      this.backSideShown = !this.backSideShown
      this.enableAudio = !this.enableAudio

      this.stopPlayingAudio()
    },

    onPlayAudio() {
      if (!this.isPlaying) {
        this.isPlaying = true
        this.audio = this.$refs.audioPlayer
        this.audio.load()
        this.audio.play()

        this.audio.onended = () => {
          this.isPlaying = false
        }
      } else {
        this.stopPlayingAudio()
      }
    },

    initShuffleSlides() {
      this.current = 0
      if (this.shuffleOn) {
        this.slides = shuffle(this.slides)
      } else {
        if (this.backFirst == false) {
          this.slides = this.cards
        } else {
          this.slides = this.slidesNew
        }
      }

      this.stopPlayingAudio()
    },

    showCardsSide() {
      this.backSideShown = false
      this.enableAudioCheck()
      this.backSlidesArray()
      if (!this.shuffleOn) {
        this.slidesNew = this.slides
      }

      this.stopPlayingAudio()
    },

    backSlidesArray() {
      this.backFirst = !this.backFirst
      return this.slides = this.slides.map(obj => {
        let rObj = {}
        rObj.back = obj.front
        rObj.front = obj.back
        rObj.front_audio_url = obj.front_audio_url
        rObj.back_audio_url = obj.back_audio_url
        rObj.front_image_url = obj.back_image_url
        rObj.back_image_url = obj.front_image_url
        return rObj
      })
    },

    enableAudioCheck() {
      if (this.frontFirst) {
        this.enableAudio = this.currentSlide.front_audio_url ? true : false
      } else {
        this.enableAudio = this.currentSlide.back_audio_url ? true : false
      }
    },

    stopPlayingAudio() {
      this.isPlaying = false
      this.audio.pause()
    }
  }
}
</script>
